import { Skeleton } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import styles from './presenceListSkeleton.module.scss';

const SkeletonHeader = (): JSX.Element => (
  <li className={styles.headerContainer}>
    <Skeleton className={classNames(styles.skeleton, styles.skeletonHeader)} />
  </li>
);

const SkeletonItem = (): JSX.Element => (
  <li className={styles.itemContainer}>
    <Skeleton className={classNames(styles.skeleton, styles.skeletonItem)} />
  </li>
);

export const PresenceListSkeleton = (): JSX.Element => (
  <>
    <SkeletonHeader />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonHeader />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonHeader />
    <SkeletonItem />
    <SkeletonItem />
  </>
);
